export default "__VITE_ASSET__DfXLRnNO__"